// tog'a #3353 (2026-10-04): «barcha razdellar telefonda moslashuvchan, ma'lumotlar tiqilib qolmasin». Telefonda (xs < 576) sarlavhaning
// global bloki (foydalanuvchi, chat, skaner, qo'ng'iroq, til, tema, sozlama, chiqish, jonli hisoblagich, batareyka) 8–10 ta belgi bo'lib
// 2–3 qatorga o'ralar va sarlavha 156–199 px (ekranning 1/5 qismi) bo'lardi. Endi telefonda faqat 💬 chat, 🔔 qo'ng'iroq va «⋯» —
// qolganlari «⋯» oynasida. Planshetda (576–1199; tog'a iPad 820/1180) sarlavha gorizontal suriladigan bo'lib, 230–370 px tugmalar yashirin
// qolardi — u yerda jonli hisoblagich, batareyka, 💬 🔔 ko'rinadi, qolgani «⋯» da. Kompyuterda (≥ 1200) — avvalgidek, hech narsa o'zgarmaydi.
// Komponentlar bir vaqtda faqat bitta joyda chiziladi (ikki nusxa → ikki marta so'rov/WebSocket bo'lmasin).
import React, { useState } from "react"
import { Button, Popover, Tooltip } from "antd"
import { EllipsisOutlined, ScanOutlined } from "@ant-design/icons"
import { Settings } from "react-feather"
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint"
import { useTranslation } from "react-i18next"
import { LiveHeaderChips } from "../live/LiveCounters"
import SubscriptionBattery from "../SubscriptionBattery"
import UserChip from "../user/UserChip"
import ChatBell from "../chat/ChatBell"
import NotificationsBell from "../notifications/NotificationsBell"
import LangSwitcher from "../LangSwitcher"
import ThemeToggleButton from "../button/ThemeToggleButton"
import LogoutButton from "../button/LogoutButton"
import "./GlobalHeaderTools.less"

export default function GlobalHeaderTools({ onSettings, scanner = false }: { onSettings: () => void; scanner?: boolean }) {
  const { t } = useTranslation()
  const bp = useBreakpoint()
  const telefon = bp.sm === false   // birinchi render'da {} → kompyuter ko'rinishi (miltillamaydi)
  const planshet = !telefon && bp.xl === false
  // iPad tik (820): sarlavha bir qator (tog'a s73) — jonli hisoblagichlar ham «⋯» ga o'tadi, aks holda 💬 🔔 o'ng chetdan chiqib ketardi; iPad yotiq (1180) — ko'rinadi
  const chiplarTashqarida = planshet && bp.lg === true
  const [ochiq, setOchiq] = useState(false)
  const skaner = scanner ? (
    <Tooltip placement="bottom" title={t("scannerTitle", "Сканер")}>
      <Button size="large" className="buttonHeader_r headermargin_r" onClick={() => { setOchiq(false); window.dispatchEvent(new CustomEvent("crm-open-scanner")) }} icon={<ScanOutlined />}></Button>
    </Tooltip>
  ) : null
  const sozlama = (
    <Tooltip placement="bottom" title={t("settings")}>
      <Button size="large" className="buttonHeader_r headermargin_r" onClick={() => { setOchiq(false); onSettings() }} icon={<Settings />}></Button>
    </Tooltip>
  )
  if (!telefon && !planshet) {
    return (
      <>
        <LiveHeaderChips />
        <SubscriptionBattery />
        <UserChip />
        <ChatBell />
        {skaner}
        <NotificationsBell />
        <LangSwitcher />
        <ThemeToggleButton />
        {sozlama}
        <LogoutButton />
      </>
    )
  }
  return (
    <>
      {chiplarTashqarida && <LiveHeaderChips />}
      {planshet && <SubscriptionBattery />}
      <ChatBell />
      <NotificationsBell />
      <Popover
        trigger="click"
        placement="bottomRight"
        visible={ochiq}
        onVisibleChange={setOchiq}
        overlayClassName="hdr-more-pop"
        destroyTooltipOnHide
        content={
          <div className="hdr-more-list" data-testid="hdr-more-list">
            <div className="hdr-more-row"><UserChip /></div>
            {telefon && <div className="hdr-more-row"><LiveHeaderChips /><SubscriptionBattery /></div>}
            {planshet && !chiplarTashqarida && <div className="hdr-more-row"><LiveHeaderChips /></div>}
            <div className="hdr-more-row">{skaner}<LangSwitcher /><ThemeToggleButton />{sozlama}<LogoutButton /></div>
          </div>
        }
      >
        <Button size="large" className="buttonHeader_r headermargin_r" icon={<EllipsisOutlined style={{ fontSize: 22 }} />} data-testid="hdr-more" aria-label={t("more", "Ещё")} />
      </Popover>
    </>
  )
}
